import { StatusTimelineConfig } from "./StatusTimelineFieldConfig";

export interface TimelineMonth {
    id: string;
    label: string;
    isReference: boolean;
}

export function generateTimelineMonths(config: StatusTimelineConfig, language: string): Array<TimelineMonth> {
    const ref = new Date(config.referenceMonth);
    const refYear = ref.getFullYear();
    const refMonth = ref.getMonth();
    const months: Array<TimelineMonth> = [];
    const formatter = new Intl.DateTimeFormat(language, { month: "short", year: "numeric" });

    for (let offset = -config.monthsBack; offset <= config.monthsForward; offset++) {
        const date = new Date(refYear, refMonth + offset, 1);
        const y = date.getFullYear();
        const m = (date.getMonth() + 1).toString().padStart(2, "0");
        months.push({
            id: `timeline:${y}-${m}`,
            label: formatter.format(date),
            isReference: offset === 0,
        });
    }

    return months;
}
